import { Injectable } from '@angular/core'
import { DatePipe } from '@angular/common'
import * as XLSX from 'xlsx'
import * as FileSaver from 'file-saver'
import { first } from 'rxjs/operators'
const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
const EXCEL_EXTENSION = '.xlsx'
const CSV_EXTENSION = '.CSV'

@Injectable()
export class ExportExcelService {
  constructor(private datePipe: DatePipe) { }

  exportMarketPerformance(json: any[], excelFileName: string): void {
    const jsonfile = json.map((obj, i) => {
      const jsonObj = {
        Indices: obj.indexName,
        'Last price (pts)': obj.indexClose,
        'Last P/E (x)': obj.pe,
        'Last Market cap (M.Baht)': obj.marketCap,
        'Index change 1D (%)': obj.indexChange,
        'Index change  (%)': obj.indexChangeYTD,
        'Avg Trading value  (M.Baht)': obj.avgTradingValue
      }
      return jsonObj
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    let ws: any = XLSX.utils.json_to_sheet(jsonfile)
    ws = this.cellFormatNumber(ws)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportExcelSummary(json: any[], excelFileName: string) {
    const ws_data = []

    json.map(obj => {
      ws_data.push(obj)
    })
  }

  exportExcelCA(datalist: any) {
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    datalist.sheet_name.map(sheetName => {
      wb.SheetNames.push(sheetName);
    });
    datalist.ws_data.map((ws_data, i) => {
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets[wb.SheetNames[i]] = ws;
    });
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      'Corporate Action' + EXCEL_EXTENSION
    )
  }

  exportExcel(json: any[], excelFileName: string): void {
    const firstHeader = [
      'Indices',
      'Last price (pts)',
      'Last P/E (x)',
      'Last Market cap (M.Baht)',
      'Index change 1D (%)',
      'Index change YTD (%)',
      'Avg Trading value YTD (M.Baht)'
    ]

    const jsonfile = json.map((obj, i) => {
      const jsonObj = {
        Indices: obj.indexName,
        'Last price (pts)': obj.indexClose,
        'Last P/E (x)': obj.pe,
        'Last Market cap (M.Baht)': obj.marketCap,
        'Index change 1D (%)': obj.indexChange,
        'Index change YTD (%)': obj.indexChangeYTD,
        'Avg Trading value YTD (M.Baht)': obj.avgTradingValue
      }
      return jsonObj
    })

    const ws: any = XLSX.utils.json_to_sheet(jsonfile)
    const ws2 = []

    json.map((body, i) => {
      const rowIndex = i + 1
      firstHeader.map((fh, fi) => {
        const cellRef = XLSX.utils.encode_cell({ c: fi, r: rowIndex })
        ws[cellRef] = {}
      })
    })

    const wb: XLSX.WorkBook = {
      Sheets: { data: ws },
      SheetNames: ['data']
    }
  }

  exportCapRaised(json: any[], excelFileName: string): void {
    const jsonfile = json.map((obj, i) => {
      const jsonObj = {
        Year: obj.year,
        'จำนวนหลักทรัพย์​ IPO': Number(obj.ipoSecurities),
        'IPO value (M.Baht)': Number(obj.ipoValue.toFixed(0)),
        'Change (%yoy)': Number(obj.ipoChange.toFixed(2)),
        'SO value (M.Baht)': Number(obj.soValue.toFixed(0)),
        'Change (% yoy)': Number(obj.soChange.toFixed(2))
      }
      return jsonObj
    })

    const j0 = jsonfile[0]
    const j1 = jsonfile[1]
    const j2 = jsonfile[2]
    const j3 = jsonfile[3]
    const j4 = jsonfile[4]

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws = XLSX.utils.json_to_sheet(
      [
        {
          A: 'Year',
          B: j0['Year'],
          C: j1['Year'],
          D: j2['Year'],
          E: j3['Year'],
          F: j4['Year'] + ' YTD'
        },
        {
          A: 'จํานวนหลักทรัพย์ IPO',
          B: j0['จำนวนหลักทรัพย์​ IPO'],
          C: j1['จำนวนหลักทรัพย์​ IPO'],
          D: j2['จำนวนหลักทรัพย์​ IPO'],
          E: j3['จำนวนหลักทรัพย์​ IPO'],
          F: j4['จำนวนหลักทรัพย์​ IPO']
        },
        {
          A: 'IPO value (M.Baht)',
          B: j0['IPO value (M.Baht)'],
          C: j1['IPO value (M.Baht)'],
          D: j2['IPO value (M.Baht)'],
          E: j3['IPO value (M.Baht)'],
          F: j4['IPO value (M.Baht)']
        },
        {
          A: 'Change (%yoy)',
          B: j0['Change (%yoy)'],
          C: j1['Change (%yoy)'],
          D: j2['Change (%yoy)'],
          E: j3['Change (%yoy)'],
          F: j4['Change (%yoy)']
        },
        {
          A: 'SO value (M.Baht)',
          B: j0['SO value (M.Baht)'],
          C: j1['SO value (M.Baht)'],
          D: j2['SO value (M.Baht)'],
          E: j3['SO value (M.Baht)'],
          F: j4['SO value (M.Baht)']
        },
        {
          A: 'Change (%yoy)',
          B: j0['Change (% yoy)'],
          C: j1['Change (% yoy)'],
          D: j2['Change (% yoy)'],
          E: j3['Change (% yoy)'],
          F: j4['Change (% yoy)']
        }
      ],
      { header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true }
    )

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
  exportCapitalValueForIpo(json: any[], excelFileName: string): void {
    const jsonfile = json.map((obj, i) => {
      const jsonObjIpo = {
        year: obj.year,
        set: obj.set,
        mai: obj.mai,
        iff: obj.iff,
        reit: obj.reit,
        total: obj.total
      }
      return jsonObjIpo
    })
    const j0 = jsonfile[0]
    const j1 = jsonfile[1]
    const j2 = jsonfile[2]
    const j3 = jsonfile[3]
    const j4 = jsonfile[4]

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws = XLSX.utils.json_to_sheet(
      [
        {
          A: 'Year',
          B: j0['year'],
          C: j1['year'],
          D: j2['year'],
          E: j3['year'],
          F: j4['year'] + ' YTD'
        },
        {
          A: 'SET',
          B: j0['set'],
          C: j1['set'],
          D: j2['set'],
          E: j3['set'],
          F: j4['set']
        },
        {
          A: 'mai',
          B: j0['mai'],
          C: j1['mai'],
          D: j2['mai'],
          E: j3['mai'],
          F: j4['mai']
        },
        {
          A: 'IFF',
          B: j0['iff'],
          C: j1['iff'],
          D: j2['iff'],
          E: j3['iff'],
          F: j4['iff']
        },
        {
          A: 'PF&REITs',
          B: j0['reit'],
          C: j1['reit'],
          D: j2['reit'],
          E: j3['reit'],
          F: j4['reit']
        },
        {
          A: 'Total',
          B: j0['total'],
          C: j1['total'],
          D: j2['total'],
          E: j3['total'],
          F: j4['total']
        }
      ],
      { header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true }
    )

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
  exportCapitalValueForSo(json: any[], excelFileName: string): void {
    const jsonfile = json.map((obj, i) => {
      const jsonObjSo = {
        year: obj.year,
        pp: obj.pp,
        po: obj.po,
        ro: obj.ro,
        sd: obj.sd,
        xe: obj.xe,
        other: obj.other,
        total: obj.total
      }
      return jsonObjSo
    })
    const j0 = jsonfile[0]
    const j1 = jsonfile[1]
    const j2 = jsonfile[2]
    const j3 = jsonfile[3]
    const j4 = jsonfile[4]

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws = XLSX.utils.json_to_sheet(
      [
        {
          A: 'Year',
          B: j0['year'],
          C: j1['year'],
          D: j2['year'],
          E: j3['year'],
          F: j4['year'] + ' YTD'
        },
        {
          A: 'PP',
          B: j0['pp'],
          C: j1['pp'],
          D: j2['pp'],
          E: j3['pp'],
          F: j4['pp']
        },
        {
          A: 'PO',
          B: j0['po'],
          C: j1['po'],
          D: j2['po'],
          E: j3['po'],
          F: j4['po']
        },
        {
          A: 'RO',
          B: j0['ro'],
          C: j1['ro'],
          D: j2['ro'],
          E: j3['ro'],
          F: j4['ro']
        },
        {
          A: 'SD',
          B: j0['sd'],
          C: j1['sd'],
          D: j2['sd'],
          E: j3['sd'],
          F: j4['sd']
        },
        {
          A: 'XE',
          B: j0['xe'],
          C: j1['xe'],
          D: j2['xe'],
          E: j3['xe'],
          F: j4['xe']
        },
        {
          A: 'Others',
          B: j0['other'],
          C: j1['other'],
          D: j2['other'],
          E: j3['other'],
          F: j4['other']
        },
        {
          A: 'Total',
          B: j0['total'],
          C: j1['total'],
          D: j2['total'],
          E: j3['total'],
          F: j4['total']
        }
      ],
      { header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true }
    )

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportMarketCapPERank(
    countryList,
    marketCapData,
    otherMarketCapList,
    totalList,
    peList,
    otherPEList,
    totalPEList
  ) {
    const jsonfile = marketCapData.map((obj, i) => {
      const jsonObj = {
        industry: obj.sector,
        indo: obj.indo.toFixed(0),
        ml: obj.ml.toFixed(0),
        ph: obj.ph.toFixed(0),
        sg: obj.sp.toFixed(0),
        th: obj.th.toFixed(0),
        vn: obj.vn.toFixed(0),
        total: obj.total.toFixed(0)
      }
      return jsonObj
    })

    jsonfile.unshift({
      industry: 'Market cap (M. USD)',
      indo: countryList[0],
      ml: countryList[1],
      ph: countryList[2],
      sg: countryList[3],
      th: countryList[4],
      vn: countryList[5],
      total: 'Total'
    })

    jsonfile.push({
      industry: 'Other',
      indo: otherMarketCapList[0].toFixed(0),
      ml: otherMarketCapList[1].toFixed(0),
      ph: otherMarketCapList[2].toFixed(0),
      sg: otherMarketCapList[3].toFixed(0),
      th: otherMarketCapList[4].toFixed(0),
      vn: otherMarketCapList[5].toFixed(0),
      total: otherMarketCapList[6].toFixed(0)
    })

    jsonfile.push({
      industry: 'Total',
      indo: totalList[0].toFixed(0),
      ml: totalList[1].toFixed(0),
      ph: totalList[2].toFixed(0),
      sg: totalList[3].toFixed(0),
      th: totalList[4].toFixed(0),
      vn: totalList[5].toFixed(0),
      total: totalList[6].toFixed(0)
    })

    jsonfile.push({
      industry: '',
      indo: '',
      ml: '',
      ph: '',
      sg: '',
      th: '',
      vn: '',
      total: ''
    })

    jsonfile.push({
      industry: 'P/E ratio (x)',
      indo: countryList[0],
      ml: countryList[1],
      ph: countryList[2],
      sg: countryList[3],
      th: countryList[4],
      vn: countryList[5],
      total: ''
    })

    peList.map((obj, i) => {
      const jsonObj = {
        industry: obj.sector,
        indo: obj.indo,
        ml: obj.ml,
        ph: obj.ph,
        sg: obj.sp,
        th: obj.th,
        vn: obj.vn,
        total: ''
      }
      jsonfile.push(jsonObj)
    })

    jsonfile.push({
      industry: 'Other',
      indo: otherPEList[0],
      ml: otherPEList[1],
      ph: otherPEList[2],
      sg: otherPEList[3],
      th: otherPEList[4],
      vn: otherPEList[5],
      total: ''
    })

    jsonfile.push({
      industry: 'Total',
      indo: totalPEList[0],
      ml: totalPEList[1],
      ph: totalPEList[2],
      sg: totalPEList[3],
      th: totalPEList[4],
      vn: totalPEList[5],
      total: ''
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    let ws: any = XLSX.utils.json_to_sheet(jsonfile, { skipHeader: true })
    ws = this.cellFormatNumber(ws)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })

    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      'ASEAN Exchanges Market cap (mil.USD) and PE ratio' + EXCEL_EXTENSION
    )
  }

  exportMarketCapTopSecurityRank(
    countryList,
    rank,
    allTotalMarket,
    totalEachIndustryByCountry,
    marketCapData
  ) {
    const preparingHeader = ['firstColumn', 'total', ...countryList]

    const header = {}
    const result = []

    preparingHeader.forEach(element => {
      header[element] = element
    })

    header['firstColumn'] =
      'ASEAN Exchanges: Top ' + rank + ' Rank Securities (M. USD)'
    header['total'] = 'Total'

    result.push(Object.assign({}, header))

    marketCapData.forEach((v, i) => {
      header['firstColumn'] = `${i} (${
        totalEachIndustryByCountry.get(i).allUnit
        } units)`
      header['total'] = allTotalMarket.get(i)

      totalEachIndustryByCountry.get(i).country.forEach((vvv, iii) => {
        header[iii] = vvv.get('marketCap')
      })

      // add blank line
      result.push(Object.assign({}, {}))

      result.push(Object.assign({}, header))

      v.forEach(vv => {
        // clear header
        preparingHeader.forEach(element => {
          header[element] = ''
        })

        const country = Object.keys(vv)[2]
        header['firstColumn'] = vv.securityName
        header['total'] = vv.total
        header[country] = vv[country]
        result.push(Object.assign({}, header))
      })
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = XLSX.utils.json_to_sheet(result, { skipHeader: true })

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      'ASEAN Exchanges Top ' +
      rank +
      ' Rank Securities (M. USD)' +
      EXCEL_EXTENSION
    )
  }

  exportGlobalIndexMemberDJSI(json: any[], excelFileName, dataProvider) {
    const jsonfile = json.map((obj, i) => {
      const jsonObj = {
        tickerLastYear: obj.tickerLastYear,
        sectorLastYear: obj.sectorLastYear,
        tickerThisYear: obj.tickerThisYear,
        sectorThisYear: obj.sectorThisYear
      }
      return jsonObj
    })

    jsonfile.unshift({
      tickerThisYear: 'Ticker',
      sectorThisYear: 'Sector',
      tickerLastYear: 'Ticker',
      sectorLastYear: 'Sector'
    })

    jsonfile.unshift({
      tickerLastYear: 'Number of Companies',
      sectorLastYear: Number(dataProvider[3].noOfCompany),
      tickerThisYear: 'Number of Companies',
      sectorThisYear: Number(dataProvider[4].noOfCompany)
    })

    jsonfile.unshift({
      tickerLastYear: 'Period as of',
      sectorLastYear: this.datePipe.transform(
        dataProvider[3].date,
        'd MMM yyyy'
      ),
      tickerThisYear: 'Period as of',
      sectorThisYear: this.datePipe.transform(
        dataProvider[4].date,
        'd MMM yyyy'
      )
    })

    jsonfile.push({
      tickerLastYear: 'Total',
      sectorLastYear: Number(dataProvider[3].noOfSecurities),
      tickerThisYear: 'Total',
      sectorThisYear: Number(dataProvider[4].noOfSecurities)
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = XLSX.utils.json_to_sheet(jsonfile, { skipHeader: true })

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportGlobalIndexMemberMSCI(json: any[], excelFileName, dataProvider) {
    const jsonfile = []
    jsonfile.push([
      'Period as of',
      null,
      this.datePipe.transform(dataProvider[3].date, 'd MMM yyyy'),
      'Period as of',
      null,
      this.datePipe.transform(dataProvider[4].date, 'd MMM yyyy'),
    ])

    jsonfile.push([
      'Number of Companies',
      null,
      Number(dataProvider[3].noOfCompany),
      'Number of Companies',
      null,
      Number(dataProvider[4].noOfCompany)
    ])

    jsonfile.push([
      'Number of Securities',
      null,
      Number(dataProvider[3].noOfSecurities),
      'Number of Securities',
      null,
      Number(dataProvider[4].noOfSecurities)
    ])

    jsonfile.push([
      'Weight contribution to total securities',
      null,
      Number(dataProvider[3].totalWeight),
      'Weight contribution to total securities',
      null,
      Number(dataProvider[4].totalWeight)
    ])

    jsonfile.push([
      'Ticker',
      'Sector',
      'Weight',
      'Ticker',
      'Sector',
      'Weight'
    ])

    json.map(obj => {
      jsonfile.push([
        obj.tickerLastYear,
        obj.sectorLastYear,
        obj.weightLastYear != null ? Number(obj.weightLastYear) : null,
        obj.tickerThisYear,
        obj.sectorThisYear,
        obj.weightThisYear != null ? Number(obj.weightThisYear) : null
      ])
    })

    jsonfile.push([
      'Total',
      null,
      Number(dataProvider[3].totalWeight),
      'Total',
      null,
      Number(dataProvider[4].totalWeight)
    ])

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = XLSX.utils.json_to_sheet(jsonfile, { skipHeader: true })

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportHistoricalIndices(json: any[], excelFileName: string): void {
    const jsonfile = json.map((obj, i) => {
      const jsonObj = {
        Market: obj.indexName,
        'Last price (pts)': obj.indexClose,
        'Last Market cap (M.Baht)': obj.marketCap
      }
      return jsonObj
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = XLSX.utils.json_to_sheet(jsonfile)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
  exportMarketLevelWatchList(
    json: any[],
    jsonType: any[],
    nameTickers: any[],
    excelFileName: string
  ): void {
    const ws_data = []
    ws_data.push(['No.', 'Ticker', 'Market', 'Sector', 'PostDate'])
    json.map((obj, i) => {
      const nameTicker = nameTickers[i]
      const data = []
      data.push([nameTicker])
      obj.map((detail, j) => {
        const date = this.datePipe.transform(detail.postdate, 'd MMM yyyy')
        data.push([
          j + 1,
          detail.ticker,
          detail.market,
          detail.sectorNameEng,
          date
        ])
      })

      ws_data.push(...data)
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    const ws = XLSX.utils.aoa_to_sheet(ws_data)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportExcelByCompany(json: any[], excelFileName: string): void {
    const ws_data2 = []
    ws_data2.push(['No', 'Sign', 'PostDate'])
    json.map(obj => {
      const group = [obj.name]
      ws_data2.push(group)
      obj.list.map((detail, i) => {
        const date = this.datePipe.transform(detail.postdate, 'd MMM yyyy')
        const de = [i + 1, detail.ticker, date]
        ws_data2.push(de)
      })
    })

    const ws = XLSX.utils.aoa_to_sheet(ws_data2)
    const wb = XLSX.utils.book_new()
    wb.Props = {
      Title: 'SheetJS Tutorial',
      Subject: 'Test',
      Author: 'Red Stapler',
      CreatedDate: new Date()
    }
    wb.SheetNames.push('Sheet')
    wb.Sheets['Sheet'] = ws
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportExcelData(ws_data, excelFileName: string) {
    const ws_data2 = ws_data

    let ws = XLSX.utils.aoa_to_sheet(ws_data2)
    ws = this.cellFormatNumber(ws)

    const wb = XLSX.utils.book_new()
    wb.Props = {
      Title: excelFileName,
      Subject: excelFileName,
      Author: 'Red Stapler',
      CreatedDate: new Date()
    }
    wb.SheetNames.push('Sheet')
    wb.Sheets['Sheet'] = ws
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
  exportExcelIpoExchangeIn5Year(
    json: any[],
    json_year: any[],
    excelFileName: string
  ): void {
    const ws_data = []
    ws_data.push(json_year)
    json.map(obj => {
      // tslint:disable-next-line:max-line-length
      const de = [
        obj.country + ' ' + obj.market,
        obj.year1,
        obj.year2,
        obj.year3,
        obj.year4,
        obj.year5,
        obj.total
      ]
      ws_data.push(de)
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }
    const ws = XLSX.utils.aoa_to_sheet(ws_data)
    // ws = this.cellFormatNumber(ws)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportExcelsectorPopupTopRank(json: any[], excelFileName: string) {
    const ws_data = []
    json.map(obj => {
      ws_data.push(obj)
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    const ws = XLSX.utils.aoa_to_sheet(ws_data)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  exportExcelsectorPopupTrendAnalysis(json: any[], excelFileName: string) {
    const ws_data = []
    json.map(obj => {
      ws_data.push(obj)
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    const ws = XLSX.utils.aoa_to_sheet(ws_data)
    // ws = this.cellFormatNumber(ws)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
  exportExcelRevenueContribution(json: any[], excelFileName: string) {
    const ws_data = json

    let ws = XLSX.utils.aoa_to_sheet(ws_data)
    ws = this.cellFormatNumber(ws)

    const wb = XLSX.utils.book_new()
    wb.Props = {
      Title: excelFileName,
      Subject: excelFileName,
      Author: 'Red Stapler',
      CreatedDate: new Date()
    }
    wb.SheetNames.push('Sheet')
    wb.Sheets['Sheet'] = ws
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  cellFormatNumber(ws) {
    function lettersToNumber(letters) {
      return letters.split('').reduce((r, a) => r * 26 + parseInt(a, 36) - 9, 0)
    }

    let column
    let row
    ws['!ref'].split(':').map(obj => {
      // tslint:disable-next-line:radix
      row = obj.replace(/[A-Z]/g, '') - 1 // replace all string is space
      const columns = [obj.replace(/[0-9]/g, '')] // replace all number is space
      column = columns.map(lettersToNumber)
      column = column[0] - 1
    })
    /* new format */

    const fmt = '0.00'
    /* change cell format of range B2:D4 */
    const range = { s: { r: 1, c: 1 }, e: { r: row, c: column } } //
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })]
        if (cell) {
          const value = cell['v']
          const ynumber = parseInt(value, 36)
          // const ynumber = parseInt(value); // y: number
          const yfloat = parseFloat(value) // y: Float
          if (ynumber || yfloat) {
            cell['t'] = 'n'
          } else if (+value === 0.0 || value === '0.00') {
            if (!(value === '' || value === ' ')) {
              cell['t'] = 'n'
            }
          }
        }
      }
    }
    return ws
  }



  exportExcelComAE(json: any[], excelFileName: string) {

    const ws_data = []

    ws_data.push(['Name', 'Market', 'Industry', 'Sector', 'Symbol'])

    json.map(obj => {
      let firstNameThai
      let lastNameThai
      let market
      let industry
      let sector
      let symbol

      if (obj.firstNameThai !== null && obj.firstNameThai !== undefined) {
        firstNameThai = obj.firstNameThai
      }
      if (obj.lastNameThai !== null && obj.lastNameThai !== undefined) {
        lastNameThai = obj.lastNameThai
      }
      if (obj.marketName !== null && obj.marketName !== undefined) {
        market = obj.marketName
      }
      if (obj.industryName !== null && obj.industryName !== undefined) {
        industry = obj.industryName
      }
      if (obj.sectorName !== null && obj.sectorName !== undefined) {
        sector = obj.sectorName
      }
      if (obj.securitySymbol !== null && obj.securitySymbol !== undefined) {
        symbol = obj.securitySymbol
      }

      ws_data.push([
        firstNameThai + ' ' + lastNameThai,
        market,
        industry,
        sector,
        symbol
      ])
    })

    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    const ws = XLSX.utils.aoa_to_sheet(ws_data)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
  exportExcelSectorIndexandProfit(ws_data, excelFileName) {
    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    const ws = XLSX.utils.aoa_to_sheet(ws_data)
    // ws = this.cellFormatNumber(ws)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
  exportExcelFinancialSecurityLevel(ws_data, excelFileName) {
    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    const ws = XLSX.utils.aoa_to_sheet(ws_data)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }

  // exportExcelAeSummary(ws_data, excelFileName) {
  exportExcelAeSummary(datalist: any) {
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    datalist.sheet_name.map(sheetName => {
      wb.SheetNames.push(sheetName);
    });
    datalist.ws_data.map((ws_data, i) => {
      const ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets[wb.SheetNames[i]] = ws;
    });
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }

    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      'AeSummary' + EXCEL_EXTENSION
    )
  }
  exportExcelCompanyContact(ws_data, excelFileName) {
    const ws_name = 'Sheet1'
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} }

    const ws = XLSX.utils.aoa_to_sheet(ws_data)

    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) {
        // tslint:disable-next-line:no-bitwise
        view[i] = s.charCodeAt(i) & 0xff
      }
      return buf
    }
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
      excelFileName + EXCEL_EXTENSION
    )
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/export-excel.service.ts